import { render } from "./ApprovedHoursCard.vue?vue&type=template&id=054d1fbc&scoped=true"
import script from "./ApprovedHoursCard.vue?vue&type=script&lang=js"
export * from "./ApprovedHoursCard.vue?vue&type=script&lang=js"

import "./ApprovedHoursCard.vue?vue&type=style&index=0&id=054d1fbc&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054d1fbc"]])

export default __exports__